import { createContext, useContext, useEffect } from 'react';

export interface WidgetZoomControls {
  canZoomIn: boolean;
  canZoomOut: boolean;
  isZoomed: boolean;
  resetZoom: () => void;
  zoomIn: () => void;
  zoomOut: () => void;
}

export type PublishWidgetZoomControls = (controls: WidgetZoomControls | null) => void;

/**
 * Bridge between a widget's chart body (which owns the zoom/pan viewport
 * state) and the widget header rendered by WidgetVisualizer (which shows the
 * zoom buttons). The visualizer provides a publish callback; the chart body
 * pushes its current controls through it on every render.
 */
export const WidgetZoomControlsContext = createContext<PublishWidgetZoomControls | null>(null);

export const useWidgetZoomControlsPublisher = (controls: WidgetZoomControls | null): void => {
  const publish = useContext(WidgetZoomControlsContext);

  // No dependency array on purpose: the zoom callbacks close over the current
  // viewport, so the latest ones must be published after every render. The
  // provider deduplicates state updates, so this does not cause render loops.
  useEffect(() => {
    publish?.(controls);
  });

  useEffect(() => {
    return (): void => {
      publish?.(null);
    };
  }, [publish]);
};
